import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

const PageTransition = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayChildren, setDisplayChildren] = useState(children);
  const previousPathRef = useRef('');
  const location = useLocation();

  const isAdminPath = (path) => path.startsWith('/admin');

  useEffect(() => {
    if (previousPathRef.current !== location.pathname) {
      const wasAdmin = isAdminPath(previousPathRef.current);
      const isAdmin = isAdminPath(location.pathname);
      const isAdminToAdmin = wasAdmin && isAdmin;

      previousPathRef.current = location.pathname;

      if (isAdminToAdmin) {
        // For admin-to-admin navigation: smooth crossfade, no loading overlay
        setIsTransitioning(true);
        // Short delay then update content and fade in
        requestAnimationFrame(() => {
          setDisplayChildren(children);
          // Allow the new content to render, then fade in
          requestAnimationFrame(() => {
            setIsTransitioning(false);
          });
        });
      } else {
        // For non-admin navigation: show dots loading
        setIsTransitioning(true);
        setDisplayChildren(children);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              setIsTransitioning(false);
            }, 200);
          });
        });
      }
    } else {
      // Same path, just update children
      setDisplayChildren(children);
    }
  }, [location.pathname, children]);

  const isAdmin = isAdminPath(location.pathname);

  return (
    <>
      {/* Only show dots loading for non-admin pages */}
      {isTransitioning && !isAdmin && (
        <div className="modern-loading">
          <div className="dots-loading">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>
      )}
      <div className={`page-content ${isTransitioning ? (isAdmin ? 'admin-transitioning' : 'transitioning') : ''}`}>
        {displayChildren}
      </div>
    </>
  );
};

export default PageTransition;
